export const steps = [
  "Find your class",
  "Select your class",
  "About your dancer",
  "Dress up",
  "Agree to our terms",
  "Review and Payment",
  "All done",
];

export const costumePrices = {
  "Senior (15+ years)": 185.0,
  "Intermediate (12-14 years)": 185.0,
  "Junior (9-11 years)": 180.0,
  "Primary (7-8 years)": 165.0,
  "Pre-Primary (5-6 years)": 160.0,
  "Pre-school (3-4 years)": 155.0,
};

export const campSteps = [
  "Find your camp",
  "Select your camp",
  "About your dancer",
  "Agree to our terms",
  "Review and Payment",
  "All done",
];
